export enum RentalTypes {
    Loan = "Loan",
    Rental = "Rental"
}

export enum CustomFieldType {
    STRING = 'STRING',
    MILEAGE = 'MILEAGE',
}

export interface CustomField {
    name: string;
    type: CustomFieldType;
    slug: string;
    required: boolean;
}

export interface Item {
    uuid: string;
    name: string;
    description: string;
    foreignId?: string;
    adminCode?: string;
    openCode?: string;
    accessCodeGenerated?: string;
    customFields?: CustomField[];
}

export interface User {
    firstName: string;
    lastName: string;
    email: string;
    accessCode: string;
    inspector: boolean;
}

export enum RentalState {
    Created = "Created",
    BorrowerPickedUp = "BorrowerPickedUp",
    LenderPickedUp = "LenderPickedUp",
    LenderReturned = "LenderReturned",
    BorrowerReturned = "BorrowerReturned"
}

export enum DelayReason {
    DelayedReturn = "DelayedReturn",
    Forgot = "Forgot"
}

export interface Rental {
    uuid: string;
    foreignId?: string;
    state: RentalState;
    itemUuid: string;
    from: string;
    until: string;
    serviceItem?: {
        name: string;
        description: string;
    };
    borrower: {
        name: string;
        email: string;
        phone: string;
        accessCode: string;
        accessKey: string;
        nfcToken?: string;
        pickedUp?: string;
        returned?: string;
        rentalEndsAfterReturn?: boolean;
        rentalEndsAutomaticallyAfterReturn?: number;
        canAccess?: boolean;
    };
    lender?: {
        accessCode: string;
        pickedUp?: string;
        returned?: string;
    };
}

export function borrowerCanAccess(rental: Rental) {
    if(rental.lender) {
        const lender = rental.lender;
        if(lender.pickedUp && !lender.returned) {
            return false;
        }
    }
    return true;
}

export function lenderCanAccess(rental: Rental) {
    if(rental.borrower) {
        const borrower = rental.borrower;
        if(!borrower.pickedUp) {
            return false;
        }
    }
    return true;
}

export interface Tenant {
    name: string;
    email?: string;
    phone?: string;
    web?: string;
    enabledTicketOnCube?: boolean;
    rentalBaseUrl: string;
    rentalInfo?: {
        en: string;
        de: string;
    }
}

export interface RentalOccupancyContent {
    /** The item uuid */
    item: string;

    /** The rental uuid if the item is currently rented. */
    rental?: string;
}
